import { Injectable } from '@angular/core';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs';
import { WindowStateActions } from '../window/window.actions';
import { OverlayActions } from './overlay.actions';
import { selectIsConnectedAndIsLiveChat } from '../live-chat/live-chat.reducer';
import { Store } from '@ngrx/store';
import { LiveChatActions } from '../live-chat/live-chat.actions';
import { LiveChatEndReason } from '../../types/enum';

@Injectable({
  providedIn: 'root',
})
export class OverlayEffects {
  constructor(private actions$: Actions, private store: Store) {}

  closeLiveChatConnectionAndWindow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverlayActions.closeApplication),
      concatLatestFrom(() => this.store.select(selectIsConnectedAndIsLiveChat)),
      map(([, [isConnected, receivedFirstOperatorMessage]]) => {
        if (isConnected) {
          if (receivedFirstOperatorMessage) {
            return LiveChatActions.endLiveChat({
              reason: LiveChatEndReason.USER_ENDED,
            });
          }
          return LiveChatActions.userCancelConnection();
        }
        return WindowStateActions.closeWindow();
      })
    )
  );
}
